// 创建 axios 实例
import axios from 'axios'
import Cookies from "js-cookie";
import {Message} from "element-ui";

const api = axios.create({   // 请求都会设置
    // 设置请求的公共基础前缀URL
    baseURL: '/prod-api',
    // 设置请求超时时间
    timeout: 100000
});

// 请求拦截器
api.interceptors.request.use(config => {
    // 在请求发送之前做一些处理，如添加 Token
    const token = Cookies.get('mam-token');
    if (token) {  // 本地缓存有token 则设置请求头token
        // Bearer 表示这是一个 Bearer 类型的令牌，意味着持有此令牌的客户端被授权访问受保护的资源。
        config.headers.Authorization = `Bearer ${token}`; // Bearer 标准Oauth 2.0 做法，后端验证令牌需移除头部
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// 响应拦截器
api.interceptors.response.use(response => {
    // 如果是文件下载
    if (response.config.responseType === 'blob') {
        return response;
    }
    if (response.data.code == 401) {
        Cookies.remove('mam-token');
        Message.error('登录已过期，请重新登录')
        // 等待2s
        setTimeout(() => {
            window.location.href = '/supermam/login';
        }, 1500)
    }
    // 对响应数据进行处理
    return response.data;
}, error => {
    // 对响应错误进行处理
    console.error(error);
    return Promise.reject(error);
});

export default api;
